module.exports = __webpack_public_path__ + "img/job-search.bdd6faaa.png";